import { styled } from '@styledComponents';
import { Column, Columns } from '@components/Columns';
import { themeMediaQuery, themeSpace, themeColor } from '@utils/styledTheme.util';

export const StyledColorColumns = styled(Columns)`
  padding-top: ${themeSpace(3)};
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(5)};
    padding-right: ${themeSpace(5)};
    max-width: unset;
  }
`;

export const StyledColorColumn = styled(Column)`
  ${themeMediaQuery('below_sm')} {
    width: 20%;
    display: inline-block;
  }
`;

export const StyledColorLabel = styled.label`
  cursor: pointer;
  font-size: 30px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: ${themeSpace(-3)};

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked ~ .circle {
    border: 1px solid #333333;
  }

  ${themeMediaQuery('below_sm')} {
    font-size: 46px;
    margin-left: -46px;
  }
`;

export const StyledColorSpan = styled.span<{ backgroundColor: string }>`
  background-color: ${(props) => '#' + props.backgroundColor};
  height: 24px;
  width: 24px;
  border-radius: 50%;
  position: absolute;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  ${themeMediaQuery('below_sm')} {
    height: 44px;
    width: 44px;
  }
`;

export const StyledColorSpanInner = styled(StyledColorSpan)<{ backgroundColor: string }>`
  background: ${(props) => props.backgroundColor};
  height: 18px;
  width: 18px;
  top: 2px;
  left: 2px;

  :before {
    z-index: 1001;
    visibility: hidden;
    border: 10px solid transparent;
    background: transparent;
    content: '';
    left: -10%;
    border-top-color: ${themeColor('mono1')};
    position: absolute;
    bottom: 10px;
  }

  :hover .tooltiptext,
  :hover :before {
    visibility: visible;
  }

  ${themeMediaQuery('below_sm')} {
    height: 38px;
    width: 38px;

    :before {
      left: 20%;
      bottom: 38px;
    }
  }
`;

export const StyledTooltip = styled.span<{ width: number; left: number }>`
  z-index: 1;
  visibility: hidden;
  position: absolute;
  width: ${(props) => props.width}px;
  bottom: 29px;
  left: ${(props) => props.left}px;
  padding: 5px;
  color: white;
  background-color: ${themeColor('mono1')};
  border-radius: 4px;
  text-align: center;
  transform: none;
  transition: opacity 0.3s ease-in-out, visibility 0.2s ease-in-out, transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  padding: ${themeSpace(4)};

  ${themeMediaQuery('below_sm')} {
    bottom: 58px;
    left: -16px;
  }
`;
